export default __webpack_public_path__ + "svg/who/logo_icex-b.svg?48ce98e5";